import { useMindstampVideoPlayer } from 'Context/MindstampVideoPlayer';

export const useMindstampSnapshot = (props) => {
  const { capture: mindstampCapture } = useMindstampVideoPlayer();
  const capture = async () => {
    const screenshot = await mindstampCapture();

    const response = await fetch(screenshot);

    const blob = response.status === 200 ? await response.blob() : null;

    const file = {
      source: screenshot,
      file: blob,
      name: 'screenshot.png',
      type: 'image/png',
    };

    return file;
  };

  return { capture };
};

export default useMindstampSnapshot;
